const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9ca0d4383ad70475df90755df79a42083621dc6a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gb-savings-acct@little-bit-pte-ltd"]={id:"9ca0d4383ad70475df90755df79a42083621dc6a"};
      